import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	FreudButtonModule,
	FreudDialogModule,
	FreudSelectModule,
} from '@freud-ds/web-components';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipModule } from 'primeng/tooltip';

import { PromptuaryNoShow } from './promptuary-no-show.component';

@NgModule({
	declarations: [PromptuaryNoShow],
	imports: [
		CommonModule,
		TranslateModule.forChild(),
		FreudSelectModule,
		TooltipModule,
		FreudButtonModule,
		FormsModule,
		FreudDialogModule,
	],
	exports: [PromptuaryNoShow],
	providers: [],
})
export class PromptuaryNoShowModule {}
